/* assets/j_auto-cart-gift.js
   NJC auto cart gift.
   Requires assets/j_cart-core.js.
*/

(function () {
  if (window.__j_auto_cart_gift_active) return;
  window.__j_auto_cart_gift_active = true;

  var refreshTimer = null;
  var isSyncing = false;

  function getWrap() {
    return document.querySelector('[data-j-auto-gift]');
  }

  function isTrue(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  function parseRules(wrap) {
    try {
      return JSON.parse(wrap.getAttribute('data-rules') || '[]');
    } catch (e) {
      return [];
    }
  }

  function getData() {
    var wrap = getWrap();

    if (!wrap) return null;

    return {
      wrap: wrap,
      customerLogged: isTrue(wrap.getAttribute('data-customer-logged')),
      rules: parseRules(wrap)
    };
  }

  function accessAllowed(access, customerLogged) {
    access = String(access || 'everyone');

    if (access === 'everyone') return true;
    if (access === 'logged') return !!customerLogged;
    if (access === 'general') return !customerLogged;

    return true;
  }

  function isPromoLine(item) {
    var props = item && item.properties ? item.properties : {};

    return (
      isTrue(props._j_reward) ||
      isTrue(props._reward1) ||
      isTrue(props._reward2) ||
      isTrue(props._reward3) ||
      isTrue(props._j_auto_gift) ||
      isTrue(props._j_exclusive_gift) ||
      isTrue(props._jcg_gift)
    );
  }

  function getSpendSubtotal(cart) {
    var sum = 0;

    (cart.items || []).forEach(function (item) {
      if (isPromoLine(item)) return;
      sum += Number(item.line_price || 0);
    });

    return sum;
  }

  function getFirstAvailableVariant(product) {
    var variants = product && product.variants ? product.variants : [];

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available === true) return variants[i];
    }

    return null;
  }

  function selectGiftProduct(rule) {
    var products = rule.products || [];
    var product;
    var variant;

    for (var i = 0; i < products.length; i++) {
      product = products[i];
      if (!product) continue;

      variant = getFirstAvailableVariant(product);
      if (!variant) continue;

      return {
        product: product,
        variant: variant
      };
    }

    return null;
  }

  function getAutoGiftLine(cart, rule) {
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      var props = items[i].properties || {};

      if (isTrue(props._j_auto_gift) && props._j_auto_gift_rule === rule.id) {
        return items[i];
      }
    }

    return null;
  }

  function getInvalidAutoGiftKeys(cart, rules, total, customerLogged) {
    var keys = [];

    (cart.items || []).forEach(function (item) {
      var props = item.properties || {};
      var rule = null;

      if (!isTrue(props._j_auto_gift)) return;

      rules.forEach(function (r) {
        if (rule) return;
        if (props._j_auto_gift_rule === r.id) rule = r;
      });

      if (
        !rule ||
        rule.enabled !== true ||
        !accessAllowed(rule.access, customerLogged) ||
        total < Number(rule.threshold || 0)
      ) {
        if (item.key) keys.push(item.key);
      }
    });

    return keys;
  }

  function removeInvalidGifts(cart, rules, total, customerLogged) {
    if (!window.JCartCore) return Promise.resolve(false);

    var keys = getInvalidAutoGiftKeys(cart, rules, total, customerLogged);
    var chain = Promise.resolve();

    if (!keys.length) return Promise.resolve(false);

    keys.forEach(function (key) {
      chain = chain.then(function () {
        return window.JCartCore.changeItem({
          id: key,
          quantity: 0
        });
      });
    });

    return chain.then(function () {
      return true;
    });
  }

  function showToast(text) {
    var toast = document.getElementById('j_auto-gift-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'j_auto-gift-toast';
      toast.className = 'j_auto-gift-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<div class="j_auto-gift-toast__box"></div>';
      document.body.appendChild(toast);
    }

    toast.querySelector('.j_auto-gift-toast__box').textContent = text || 'Your free gift has been added to cart.';
    toast.classList.add('is-active');

    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(function () {
      toast.classList.remove('is-active');
    }, 2600);
  }

  function addGift(rule, selected) {
    if (!window.JCartCore || !selected || !selected.variant) return Promise.resolve(false);

    return window.JCartCore.addItem({
      id: selected.variant.id,
      quantity: 1,
      properties: {
        _j_auto_gift: '1',
        _j_auto_gift_rule: rule.id,
        _j_auto_gift_variant: String(selected.variant.id),
        _j_auto_gift_label: rule.label || 'Reward',
        _source: 'minicart'
      }
    }).then(function () {
      showToast(rule.toast_text);
      return true;
    });
  }

  function sync(cart) {
    var data = getData();
    var total;
    var chain;

    if (!data || !data.rules.length) return Promise.resolve(false);

    total = getSpendSubtotal(cart);

    return removeInvalidGifts(cart, data.rules, total, data.customerLogged).then(function (removed) {
      if (removed) {
        queueRefresh(250);
        return true;
      }

      chain = Promise.resolve(false);

      data.rules.forEach(function (rule) {
        chain = chain.then(function (changed) {
          var selected;

          if (changed) return true;
          if (!rule || rule.enabled !== true) return false;
          if (!accessAllowed(rule.access, data.customerLogged)) return false;
          if (total < Number(rule.threshold || 0)) return false;
          if (getAutoGiftLine(cart, rule)) return false;

          selected = selectGiftProduct(rule);
          if (!selected) return false;

          return addGift(rule, selected);
        });
      });

      return chain;
    });
  }

  function refresh() {
    if (isSyncing) return;
    if (!window.JCartCore) return;

    isSyncing = true;

    window.JCartCore.getCart()
      .then(sync)
      .catch(function () {})
      .finally(function () {
        isSyncing = false;
      });
  }

  function queueRefresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);

    refreshTimer = setTimeout(function () {
      refresh();
    }, typeof delay === 'number' ? delay : 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    queueRefresh(80);
  });

  document.addEventListener('cart:refresh', function () {
    queueRefresh(160);
  });

  document.addEventListener('j:cart:mutated', function () {
    queueRefresh(220);
  });

  window.JAutoCartGift = {
    refresh: refresh,
    queueRefresh: queueRefresh
  };
})();